import { COLORS } from '@/shared/constants/colors';
import { IconName } from '@/shared/uikit/Icon';

export const MAX_TASK_FILES = 10;

export enum CaseBackground {
  General = 'GENERAL',
  House = 'HOUSE',
  Key = 'KEY',
  Invoice = 'INVOICE',
  Certificate = 'CERTIFICATE',
  Users = 'USERS',
  Buildings = 'BUILDINGS',
  Bank = 'BANK',
  Briefcase = 'BRIEFCASE',
  Globe = 'GLOBE',
  Archive = 'ARCHIVE',
}

export const CASE_BACKGROUND_STYLES: Record<
  CaseBackground,
  {
    icon: IconName;
    iconColor: string;
    background: string;
    backgroundFull: string;
  }
> = {
  [CaseBackground.General]: {
    icon: 'clipboard-text',
    iconColor: COLORS.systemSky200,
    background: COLORS.systemSky100,
    backgroundFull: COLORS.systemSky100,
  },
  [CaseBackground.House]: {
    icon: 'house-line',
    iconColor: COLORS.systemLight100,
    background: COLORS.colorVfoCases[0],
    backgroundFull: `url(/assets/pages/vfo/cases/caseBg2.png)`,
  },
  [CaseBackground.Key]: {
    icon: 'key',
    iconColor: COLORS.systemLight100,
    background: `url(/assets/pages/vfo/cases/caseBg3_preview.png)`,
    backgroundFull: `url(/assets/pages/vfo/cases/caseBg3.png) lightgray -347.172px -840px / 149.794% 805.656% no-repeat`,
  },
  [CaseBackground.Invoice]: {
    icon: 'invoice',
    iconColor: COLORS.systemLight100,
    background: COLORS.colorVfoCases[1],
    backgroundFull: `url(/assets/pages/vfo/cases/caseBg4.png)`,
  },
  [CaseBackground.Certificate]: {
    icon: 'certificate',
    iconColor: COLORS.systemLight100,
    background: COLORS.colorVfoCases[2],
    backgroundFull: `url(/assets/pages/vfo/cases/caseBg5.png)`,
  },
  [CaseBackground.Users]: {
    icon: 'users-three',
    iconColor: COLORS.systemLight100,
    background: COLORS.colorVfoCases[3],
    backgroundFull: `url(/assets/pages/vfo/cases/caseBg6.png)`,
  },
  [CaseBackground.Buildings]: {
    icon: 'buildings',
    iconColor: COLORS.systemLight100,
    background: COLORS.colorVfoCases[4],
    backgroundFull: `url(/assets/pages/vfo/cases/caseBg7.png)`,
  },
  [CaseBackground.Bank]: {
    icon: 'bank',
    iconColor: COLORS.systemLight100,
    background: COLORS.colorVfoCases[5],
    backgroundFull: `url(/assets/pages/vfo/cases/caseBg8.png)`,
  },
  [CaseBackground.Briefcase]: {
    icon: 'briefcase',
    iconColor: COLORS.systemLight100,
    background: COLORS.colorVfoCases[6],
    backgroundFull: `url(/assets/pages/vfo/cases/caseBg9.png)`,
  },
  [CaseBackground.Globe]: {
    icon: 'globe',
    iconColor: COLORS.systemLight100,
    background: COLORS.colorVfoCases[7],
    backgroundFull: `url(/assets/pages/vfo/cases/caseBg10.png)`,
  },
  [CaseBackground.Archive]: {
    icon: 'folder',
    iconColor: COLORS.systemLight100,
    background: COLORS.systemDark100,
    backgroundFull: COLORS.systemDark100,
  },
};
